import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { getPoster } from '../utils';

import styles from './PreviewMode.css';

const PreviewMode = ({ posterImage, thumbnails, onClick, buttonSize = 64 }) => {
  const previewNode = useRef(null);
  const [poster, setPoster] = useState(null);
  const buttonStyle = buttonSize && {
    height: `${buttonSize}px`,
    width: `${buttonSize}px`,
    fontSize: `${(buttonSize / 3) * 2}px`,
    left: `calc(50% - ${buttonSize}px / 2)`,
    top: `calc(50% - ${buttonSize}px / 2)`,
  };

  useEffect(() => {
    setPoster(
      getPoster(
        posterImage,
        thumbnails?.[0]?.sources,
        previewNode?.current?.clientWidth
      )
    );
  }, [previewNode]);

  return (
    <button
      className={styles.previewModeWrapper}
      type="button"
      style={{ backgroundImage: 'url(' + poster + ')' }}
      onClick={onClick}
      ref={previewNode}
    >
      <div className={styles.playButton} style={buttonStyle} />
    </button>
  );
};

PreviewMode.propTypes = {
  posterImage: PropTypes.string,
  thumbnails: PropTypes.object,
  onClick: PropTypes.func,
  buttonSize: PropTypes.number,
};

export default PreviewMode;
